export const LOGIN = "LOGIN";
export const CONFIRM_EMAIL = "CONFIRM_EMAIL";
export const VERIFICATION_CODE = "VERIFICATION_CODE";
export const USER_PWD = "USER_PWD";
export const SET_MAIN_USER_LOGIN = "SET_MAIN_USER_LOGIN";
export const SET_RESEND_OTP = "SET_RESEND_OTP";
export const SET_OTP_EXPIRED = "SET_OTP_EXPIRED";
// for myAccount tabs
export const CURRENT_TAB = "CURRENT_TAB";

// for loader
const ACTION_LOADER = "ACTION_LOADER";

const SET_LOGIN = "SET_LOGIN";
const SET_USER_PWD = "SET_USER_PWD";
const SET_AUTHENTICATED = "SET_AUTHENTICATED";
const SET_CONFIRM_EMAIL = "SET_CONFIRM_EMAIL";
const SET_VERIFICATION_CODE = "SET_VERIFICATION_CODE";
const SET_FORBIDDEN = "SET_FORBIDDEN";
const SET_USER_ROLE = "SET_USER_ROLE";
const SET_CURRENT_TAB = "SET_CURRENT_TAB";
const SET_LOGIN_OTP_SEND_SUCCESSFUL = "SET_LOGIN_OTP_SEND_SUCCESSFUL";

// loginUser is for the action no need to add it in the switch statement
export const loginUser = (payload) => ({
  type: LOGIN,
  payload,
});

export const setUserLogin = (payload) => ({
  type: SET_LOGIN,
  payload,
});

export const userPassword = (payload) => ({
  type: USER_PWD,
  payload,
});

export const setUserPassword = (payload) => ({
  type: SET_USER_PWD,
  payload,
});

export const confirmEmail = (payload) => ({
  type: CONFIRM_EMAIL,
  payload,
});

export const setConfirmEmail = (payload) => ({
  type: SET_CONFIRM_EMAIL,
  payload,
});

export const verificationCode = (payload) => ({
  type: VERIFICATION_CODE,
  payload,
});

export const setUserAuthentication = (payload) => ({
  type: SET_AUTHENTICATED,
  payload,
});

export const setUserForbidden = (payload) => ({
  type: SET_FORBIDDEN,
  payload,
});

export const setVerificationCode = (payload) => ({
  type: SET_VERIFICATION_CODE,
  payload,
});

export const setUserRole = (payload) => ({
  type: SET_USER_ROLE,
  payload,
});

export const setLoaderState = (loadingState) => ({
  type: ACTION_LOADER,
  loadingState,
});

export const setCurrentTab = (payload) => ({
  type: SET_CURRENT_TAB,
  payload,
});

export const setSentOtpSuccessFul = (payload) => ({
  type: SET_LOGIN_OTP_SEND_SUCCESSFUL,
  payload,
});

export const setMainUserLogin = (payload) => ({
  type: SET_MAIN_USER_LOGIN,
  payload,
});

export const setResendOtp = (payload) => ({
  type: SET_RESEND_OTP,
  payload,
});

export const setOtpExpired = (payload) => ({
  type: SET_OTP_EXPIRED,
  payload,
});

const initialState = {
  isAuthLoading: false,
  loginAuth: "",
  resetPassword: {},
  isAuthenticated: false,
  confirmEmailData: false,
  verificationCodeData: "",
  isForbidden: false,
  userRole: "",
  currentTab: "",
  optStatus: "",
  otpExpired: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case SET_LOGIN:
      return { ...state, loginAuth: action.payload };
    case SET_USER_PWD:
      return { ...state, resetPassword: action.payload };
    case ACTION_LOADER:
      const { loadingState } = action;
      return { ...state, isAuthLoading: loadingState };
    case SET_OTP_EXPIRED:
      return { ...state, otpExpired: action.payload };
    case SET_AUTHENTICATED:
      return { ...state, isAuthenticated: action.payload };
    case SET_CONFIRM_EMAIL:
      return { ...state, confirmEmailData: action.payload };
    case SET_VERIFICATION_CODE:
      return { ...state, verificationCodeData: action.payload };
    case SET_FORBIDDEN:
      return { ...state, isForbidden: action.payload };
    case SET_USER_ROLE:
      return { ...state, userRole: action.payload };
    case SET_CURRENT_TAB:
      return { ...state, currentTab: action.payload };
    case SET_LOGIN_OTP_SEND_SUCCESSFUL:
      return { ...state, optStatus: action.payload };
    default:
      return state;
  }
};
